import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, CardMedia, Container, CssBaseline, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useFormik } from 'formik';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import axios from 'axios';
import Logo from '../../../assets/Login_logo.png';
import { CommonConfig } from '../../../config/common-config';
import Background from '../../../assets/Background.jpg';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import PrivacyFooter from '../footer';

// for dev ENV:
// let host = 'itec.maveric-systems.com/login';
// let host = 'advith.maveric-systems.com/login';

// for Pre-prod ENV:
// let host = 'itec.itecapp.in/login';
// let host = 'advith.itecapp.in/login';
// let host = 'api.itecapp.in/login';

// for prod ENV:
// let host = 'itec.advithitec.in/login';
// let host = 'advith.advithitec.in/login';
// let host = 'api.advithitec.in/login';

let host = window.location.host;
console.log("'host'", host);

// let href = window.location.href;
//console.log("'href'", href);

// let protocol = window.location.protocol;
//console.log("'protocol'", protocol);

// let hostname = window.location.hostname;
//console.log("'hostname'", hostname);

// let pathname = window.location.pathname;
//console.log("'pathname'", pathname);

// let port = window.location.port;
//console.log("'port'", port);

let subDomainName = host.split('.')[0];
console.log("'subDomainName'", subDomainName);

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: '25px',
        // marginBottom: '75px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: '3% 11%',
        borderRadius: '10px',
    },
    errorReset: {
        color: 'red',
        fontWeight: '400',
        fontSize: '14px',
    },
    bgImage: {
        width: '100%',
        backgroundImage: `url(${Background})`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        // height: '100%',
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '10px 25px',
        letterSpacing: 'normal',
        backgroundColor: '#504cad !important',
        boxShadow: 'none !important',
        fontFamily: 'Rubik !important',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    logo: {
        width: '100%',
    },
    media: {
        width: '35%',
        paddingTop: '0%',
        paddingBottom: '0%',
    },
    submit: {
        height: '46px',
        boxShadow: 'none !important',
    },
    success: {
        fontFamily: 'Rubik',
        color: 'green',
        fontSize: '14px',
        fontWeight: '600',
        paddingBottom: '5px',
    },
    scroll: {
        maxHeight: 'auto',
        minHeight: '100vh',
    },
}));
const ResetPassword = (props) => {
    const username = JSON.parse(sessionStorage.getItem('user'));
    const { userName } = username.result.data;
    const history = useHistory();
    const classes = useStyles();
    const [AllImcs, setAllImcs] = useState([]);
    const [success, setSuccess] = useState('');
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [error, setError] = useState('');
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const dataReset = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const setReset = dataReset && dataReset.data.isResetPasswordRequired;
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [currentPassword, setCurrentPassword] = React.useState(false);
    const [password, setPassword] = React.useState(false);
    const [confirmPassword, setConfirmPassword] = React.useState(false);
    const jwttoken = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const [IMCLogo, setIMCLogo] = useState('');

    const allImcsOptions = (inputs) => {
        const OptionList = inputs.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };
    const handleClose = () => {
        setShowBtnLoader(false);
    };

    const formik = useFormik({
        initialValues: {
            currentpassword: '',
            password: '',
            confirmpassword: '',
            // tennantName: '',
        },
        validationSchema: Yup.object({
            currentpassword: Yup.string().required('Please enter your Current Password'),
            password: Yup.string().min(6, 'Password must be atleast 6 characters').required('Enter New Password'),
            confirmpassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'New Password and Confirm Password should be same')
                .required('Confirm Password is required'),
        }),
        onSubmit: (values) => {
            const data = {
                userName,
                currentPassword: values.currentpassword,
                newPassword: values.password,
                tennantName: subDomainName,
                isResetPasswordRequired: false,
            };

            return axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/reset-password`, data, jwttoken)
                .then((result) => {
                    if (result.data === 'SUCCESS') {
                        setShowBtnLoader(true);
                        setTimeout(() => {
                            setShowBtnLoader(false);
                            setSuccessPop(true);
                        }, 1500);
                        setTimeout(() => {
                            history.push('/');
                        }, 3000);
                    }
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowBtnLoader(true);
                        setTimeout(() => {
                            setShowBtnLoader(false);
                            setErrorPop(true);
                        }, 1500);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        },
    });

    const navigate = () => {
        history.push('/menu');
    };

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => setAllImcs(response.data.content))
            .catch(() => {});

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-imc-logo/${subDomainName}`)
            .then((response) => {
                setIMCLogo(response.config.url);
            })
            .catch((err) => {});
    }, [userToken]);

    return (
        <div className={classes.bgImage}>
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Password reset successfully" />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <div className={classes.scroll}>
                <Container component="main" maxWidth="sm" className={classes.overflowHidden}>
                    <CssBaseline />
                    <div className={classes.paper}>
                        <CardMedia className={classes.media}>
                            <img src={IMCLogo} alt="logo" className={classes.logo} />
                        </CardMedia>
                        <Typography variant="subtitle1" gutterBottom className="forgotpass fontRubik">
                            Reset your password
                        </Typography>
                        <div className="main-container w100">
                            <form className="mt30" onSubmit={formik.handleSubmit}>
                                <Grid container spacing={3}>
                                    {/* <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth>
                                            <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                                {' '}
                                                Select Domain
                                            </InputLabel>
                                            <Select
                                                name="tennantName"
                                                onChange={formik.handleChange}
                                                value={formik.values.tennantName}
                                                className={classes.bottomLine}
                                                native
                                            >
                                                <option>Select IMC</option>
                                                {allImcsOptions(AllImcs)}
                                            </Select>
                                        </FormControl>
                                    </Grid> */}
                                    <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth>
                                            <InputLabel className="lbl" htmlFor="currentpassword" shrink>
                                                {' '}
                                                Current password
                                            </InputLabel>
                                            <Input
                                                className="bottom"
                                                fullWidth
                                                type={currentPassword ? 'text' : 'password'}
                                                id="currentpassword"
                                                label="Current password"
                                                name="currentpassword"
                                                autoComplete="current-password"
                                                // required
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.currentpassword}
                                                placeholder="Current password"
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => setCurrentPassword(!currentPassword)}
                                                        >
                                                            {currentPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                            {formik.touched.currentpassword && formik.errors.currentpassword ? (
                                                <span className={classes.errorReset}>{formik.errors.currentpassword}</span>
                                            ) : null}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth>
                                            <InputLabel className="lbl" htmlFor="password" shrink>
                                                {' '}
                                                New Password
                                            </InputLabel>
                                            <Input
                                                className="bottom"
                                                fullWidth
                                                type={password ? 'text' : 'password'}
                                                id="password"
                                                label="Password"
                                                name="password"
                                                autoComplete="Password"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.password}
                                                placeholder="New password"
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => setPassword(!password)}
                                                        >
                                                            {password ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                            {formik.touched.password && formik.errors.password ? (
                                                <span className={classes.errorReset}>{formik.errors.password}</span>
                                            ) : null}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth>
                                            <InputLabel className="lbl" htmlFor="confirmpassword" shrink>
                                                {' '}
                                                Confirm password
                                            </InputLabel>
                                            <Input
                                                className="bottom"
                                                fullWidth
                                                type={confirmPassword ? 'text' : 'password'}
                                                id="confirmpassword"
                                                label="Confirm password"
                                                name="confirmpassword"
                                                autoComplete="Confirm-Password"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.confirmpassword}
                                                placeholder="Confirm password"
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => setConfirmPassword(!confirmPassword)}
                                                        >
                                                            {confirmPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }
                                            />
                                            {formik.touched.confirmpassword && formik.errors.confirmpassword ? (
                                                <span className={classes.errorReset}>{formik.errors.confirmpassword}</span>
                                            ) : null}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <div className={classes.centerAlign}>
                                            {(showBtnLoader && (
                                                <Button className={classes.submit} variant="outlined" fullWidth disabled>
                                                    <CircularProgress color="primary" size={24} />
                                                </Button>
                                            )) || (
                                                <Button
                                                    type="submit"
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    className={classes.button}
                                                >
                                                    Reset
                                                </Button>
                                            )}
                                            <p className={classes.success}>{success}</p>
                                            <p className={classes.error}>{error}</p>
                                        </div>
                                        {setReset === false ? (
                                            <div>
                                                <Link
                                                    onClick={navigate}
                                                    className="forgotpass"
                                                    variant="body2"
                                                    style={{ textDecoration: 'underline' }}
                                                >
                                                    Back
                                                </Link>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </Grid>
                                </Grid>
                            </form>
                        </div>
                    </div>
                </Container>
            </div>
            <PrivacyFooter />
        </div>
    );
};

export default ResetPassword;
